import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import config from "../config";

const reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
  config: {
    connectionString: config.appInsightsConnectionString,
    extensions: [reactPlugin],
    enableAutoRouteTracking: false,
    enableUnhandledPromiseRejectionTracking: true,
    autoTrackPageVisitTime: true,
  },
});

if (config.appInsightsConnectionString) {
  appInsights.loadAppInsights();
}

export { reactPlugin, appInsights };
